module.exports = "/_next/static/images/logo-7b91478be0ecf3b77e502765723c9a5c.svg";